import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Move these to environment variables for security
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBrFYzMmUwB9SNCGkMi4NDftUthcG84OI4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "agent-dashboard-bd3a6.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "agent-dashboard-bd3a6",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "agent-dashboard-bd3a6.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "291788824132",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:291788824132:web:18305479b4209ca37ce611",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-QJPZWP7QDQ",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
